import React, { Component } from "react";
import PropTypes from 'prop-types'
import { Button, Col, Comment, Tooltip } from 'antd';
import _, { bindAll, isFunction, map } from "lodash";

import MessageEditor from 'components/MessageEditor';
import ModalUtil from 'utils/modalUtil';
import WarningPopup from 'components/WarningPopup';
import { CellRenderers, Sorters } from 'utils/tableUtils';
import { antiTransformComment } from 'utils/commentUtil';
import { EditIcon } from 'components/Icons';
import { withActiveUser } from 'contexts/ActiveUserContext';
import FindingAPI from "restAPI/FindingAPI";
class CommentComponent extends Component{
  static defaultProps = {
    showEditButton: false,
    commentList: [],
    onCommentSubmit: _.noop,
    colAttr: {
      span: 24
    },
    colWrap: false
}
  constructor(props) {
    super(props);
    this.state = {
      editId: '',
      hasChange: false,
    }
    bindAll(
      this,
      "onEdit",
      "onCancel",
      "onChange",
      "onSubmit",
      "renderItem"
    )
  }

  onEdit(id, cancel) {
    const {hasChange, editId} = this.state;
    if (hasChange && editId) {
      ModalUtil.show({
        content: <WarningPopup
          type=""
          title={`The changes in the comment will not be saved. Are you sure want to continue?`}
          okText="Yes"
          onOk={() => {
            this.setState({editId: id, hasChange: false});
          }}
        />
    })
    } else {
      this.setState({editId: id, hasChange: false});
    }
  }

  async onSubmit(payload) {
    const { editId } = this.state;
    if (this.props.onCommentSubmit) {
      if (editId) {
        payload.commentId = editId;
      }
      await this.props.onCommentSubmit(payload);
      this.props.showEditButton && this.setState({editId: '', hasChange: false});
    }
  }

  onCancel(){
    this.onEdit(null, 'cancel');
  }

  onChange(content) {
    const { editId } = this.state;
    const { commentList } = this.props;
    const obj = commentList.find(l => l.id === editId);
      if (obj) {
        this.setState({hasChange: obj.comment !== content});
      }
  }

  renderItem(item) {
    const { editId } = this.state;
    const { activeUser, showEditButton, getItemDataProps, state, finding, canEdit, renderExtraMeta } = this.props;
    const itemDataProps = getItemDataProps(item); // trigger for every item from the parent component...
    if (showEditButton) {
      itemDataProps.submitText = "Save";
    }
    const showEdit = isFunction(canEdit) ? canEdit(item) : showEditButton;
    itemDataProps.datetime = (
      <>
        {itemDataProps.datetime}
        {renderExtraMeta && renderExtraMeta(item)}
        { activeUser?.email === item.createdBy && showEdit && (
            <>
              <Button type='link' size="small" onClick={() => this.onEdit(item.id || item.ticketId)} ><EditIcon /></Button>
              { item.isEdited && (
                <Tooltip title={ CellRenderers.TIME(item.updatedAt)} placement="top">
                  <small>(edited)</small>
                </Tooltip>
              )}
            </>
          )
        }
      </>
    );

    return (
      <>
        {
          // ticketId is used because the tickets comment entry doesn't have id, is has ticketId which is unique
          (item.id || item.ticketId) === editId
          ? <MessageEditor
              toolBarIdentifier={`comment-${item.id || item.ticketId}`}
              alwaysOpen autoFocus
              onSubmit={this.onSubmit}
              onCancel={this.onCancel}
              onChange={this.onChange}
              {...itemDataProps}
              content={ antiTransformComment(item.note || item.comment || item.message) }
              users={state.users}
              findingId={finding?.id}
              attachments={item.attachments}
              attachmentV2Handler={this.props.attachmentV2Handler}
              hideOldUpload
              />
          : <Comment {...itemDataProps} />
        }
      </>
    )
  }

  render () {
    const { commentList, colWrap, colAttr } = this.props;
    return (
      <>
          {
            map(commentList.sort(Sorters.DATE('createdAt', true)), (comment, i) => {
              const element = this.renderItem(comment);
              return colWrap ? <Col {...colAttr} key={`item-${i}`}>{element}</Col> : <div key={`item-${i}`}>{element}</div>;
            })
          }
      </>
    )
  }

}

CommentComponent.propTypes = {
  getItemDataProps: PropTypes.func.isRequired,
  commentList:  PropTypes.arrayOf(PropTypes.object).isRequired
}

export const getCommentChangeAPIFunction = (id, payload) => {
    let commentMethod = 'postComment'
    if (payload.commentId) {
        commentMethod = 'editComment';
    }
    return FindingAPI[commentMethod](id, payload);
}

export default withActiveUser(CommentComponent);
